module.exports = __webpack_public_path__ + "img/setting_14.5193c0a5.svg";